// removed by extract-text-webpack-plugin
module.exports = {"component":"_2gkJ7BwG_M7bs_qjFNKRry","container":"_12jNPr5wuOw3DeoIdFg2rA","messagePlaceholder":"_1SVJIApqJCLUAHYr4ZLGni"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Pages/Messages/MessageThreadContainer/MessageThreadContainer.css
// module id = 1353
// module chunks = 0